import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  buttonContainer: {
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    width: '100%',
  },
  customActionsContentWrapper: {
    flex: 1,
    minWidth: 0,
    width: '100%',
    '& > *': {
      width: '100%',
    },
  },
  splitButtonContainer: {
    width: '100%',
    gap: theme.spacing(2),
  },
  buttonGroup: {
    gap: theme.spacing(2),
  },
  rightButtonGroup: {
    gap: theme.spacing(2),
    marginLeft: 'auto',
  },
}));
